export default function formatDate(date) {
  const d = new Date(date);
  return new Intl.DateTimeFormat("pt-BR").format(d);
}
